<template>
        <b-navbar class="nav" fixed-top>
            <template slot="brand">
                <b-navbar-item tag="router-link" :to="{ path: '/' }">
                    <img src="../assets/suitelogo.png"
                         alt="SEQu-SUITE">
                </b-navbar-item>
            </template>
            <template slot="start">
                <b-navbar-item tag="a" href="/sequ-health-pro">SEQu-HEALTH Pro</b-navbar-item>
                <b-navbar-item tag="a" href="/sequ-face">SEQu-FACE</b-navbar-item>
                <b-navbar-item tag="a" href="/sequ-doc">SEQu-DOC</b-navbar-item>
                <b-navbar-item tag="a" href="/sequ-lab">SEQu-LAB</b-navbar-item>
                <b-navbar-dropdown hoverable position="is-bottom-left" label="Trust Economy">
                    <b-navbar-item href="/trust-economy">
                        Understanding the Trust Economy
                    </b-navbar-item>
                    <b-navbar-item href="https://drive.google.com/open?id=17ZIg03brsTErMeDfscsZpFLL4G7r3a8z" target="_blank">
                        New Normal Health Security Regulations
                    </b-navbar-item>
                </b-navbar-dropdown>
            </template>
            <template slot="end">
                <b-navbar-item href="/about">About</b-navbar-item>
                <b-navbar-item href="/contact">Contact Us</b-navbar-item>
            </template>
        </b-navbar>
</template>

<script>
    import BNavbar from "buefy/src/components/navbar/Navbar";
    import BNavbarItem from "buefy/src/components/navbar/NavbarItem";
    export default {
        name: "Nav",
        components: {BNavbarItem, BNavbar}
    }
</script>

<style scoped>
    .nav {
        border-bottom: solid 1px #262626;
    }
</style>